export default __webpack_public_path__ + "static/media/pay_device.837fe37e.png";